import DownloadAbaFileRequestModelBase from '../_generated/modelBases/download-aba-file-request-model-base';

export default class DownloadAbaFileRequestModel extends DownloadAbaFileRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
